<div>
	<nb-icon *ngIf="rowData.autoApproveShare" icon="checkmark"></nb-icon>
	<nb-icon *ngIf="!rowData.autoApproveShare" icon="close"></nb-icon>
</div>
